export default "__VITE_ASSET__Dg27I$6c__"